import animations from 'Assets/js/modules/animations';
import jsUtils from '@pernod-ricard-global-cms/jsutils';
import Vue from 'vue';
import articleList from 'Assets/vue/blocks/articleList.vue';

export default function articleListJs(options = {}) {
  try {
    const { block } = options;
    jsUtils.loadCss(block.dataset.assetkey, options).then(() => {
      animations.fadeIn(block);
      const mountElement = block.children[0].children[1];
      new Vue({
        render: (h) => h(articleList),
        data: { ...mountElement.dataset }
      }).$mount(mountElement);
    });
  } catch (error) {
    console.error(error);
  }
}
